export default "#### We can only deliver in NSW\n\nAt the moment, we can only deliver to addresses in NSW, but we’re hoping to expand our reach soon.\n";